module.exports = __webpack_public_path__ + "media/application/images/ICAS_Full_colour_negative_Firm_Version-8f0922718036237c4e816a0bedbb9354.png";